/* eslint-disable react/no-unescaped-entities */
import {
  params,
  arrayOf,
  string,
  fragment,
  shape,
  bool,
  extend,
  customType,
  QueryProvider,
  useDataModel
} from '@thd-nucleus/data-sources';
import React, { useContext, useEffect } from 'react';
import { Metadata } from '@thd-olt-component-react/metadata';
import { MovingCalculator } from '@thd-olt-component-react/moving-calculator';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { Heading, Image, Col, Row } from '@thd-olt-component-react/core-ui';
import '../../styles/moving-calculator.scss';

export const MovingBoxCalculator = () => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('project-calculator.page-load', { calculatorType: 'moving' });
  }, []);

  const crumbs = [
    {
      label: 'Home',
      url: '/'
    },
    {
      label: 'DIY Projects and Ideas',
      url: '/c/diy_projects_and_ideas'
    },
    {
      label: ' Project Calculators',
      url: '/c/project_calculators'
    },
    {
      label: 'Moving Calculator',
      url: '/c/moving-box-calculator'
    },
  ];

  const metaDataProperties = {
    title: 'Moving Calculator - The Home Depot',
    // eslint-disable-next-line max-len
    description: 'Calculate how many moving boxes and other packing supplies you need with The Home Depot\'s Moving Supplies Calculator. Get a free estimate today!',
    canonicalURL: '/c/moving-supplies-calculator',
    type: 'Calculator',
    siteName: 'The Home Depot',
    fbAdmins: '100005416960152',
    alternateUrlEnCa: 'https://www.movingcalculatorhomedepot.ca/',
    alternateUrlFrCa: 'https://www.movingcalculatorhomedepot.ca/fr',
    alternateUrlEnUs: 'https://www.homedepot.com/c/moving-supplies-calculator',
  };

  return (
    <div className="grid isBound">
      <Row name="moving-calculator__wrapper">
        <ErrorBoundary name="moving-calculator-metadata">
          <Metadata data={metaDataProperties} />
        </ErrorBoundary>
        <ErrorBoundary>
          <Col>
            <QueryProvider cacheKey="moving">
              <Breadcrumbs
                className="moving-calculator__breadcrumbs"
                staticCrumbs={crumbs}
              />
            </QueryProvider>
          </Col>
          <Row>
            <h1
              className="moving-calculator__header"
              id="moving-supplies-header"
            >
              Moving Supplies Calculator
            </h1>
            <div className="col__12-12">
              <QueryProvider cacheKey="movingContainer">
                <div className="moving-calculator__container">
                  <MovingCalculator />
                </div>
              </QueryProvider>
            </div>
            <div className=" col__12-12 moving-calculator__text">
              <h1 className="moving-calculator__heading">Make Your Move Easier With Our Help</h1>
              <div className="moving-calculator__description">
                <p className="moving-calculator__description--smalltext">
                  Pack and protect your belongings like a pro with The Home Depot moving calculator.
                  Whether you’re moving across the country or across the street you can use the calculator
                  to determine all the moving supplies you’ll need – no more repeat shopping trips to
                  prepare for your move!
                </p>
                <p className="moving-calculator__description--smalltext">
                  From moving boxes to bubble wrap, our moving calculator will
                  generate a personalized list of moving supplies
                  you’ll need to safely transport your belongings to your new home.
                </p>
                <p className="moving-calculator__description--smalltext">
                  Once your moving checklist is complete, you can add the recommended supplies directly to
                  your online shopping
                  cart for in-store pick up or home delivery. The Home Depot also offers moving truck rentals
                  and other moving equipment rentals.
                </p>
                <p className="moving-calculator__description--smalltext">
                  For more moving tips like learning how to pack for a move and exclusive discounts and coupons,
                  sign up for our newsletter.
                </p>
              </div>
            </div>
          </Row>
        </ErrorBoundary>
      </Row>
    </div>
  );
};

MovingBoxCalculator.dataModel = extend({}, MovingCalculator);